.panel {
  display: flex;
  gap: var(--space-4);
  align-items: flex-start;
}

.tile {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
}

.body {
  display: grid;
  gap: var(--space-2);
}

.heading {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  align-items: center;
  margin: 0;
}

.line {
  margin: 0;
  color: var(--color-text);
  line-height: 1.7;
}

.block {
  margin: var(--space-2) 0 0;
  color: var(--color-text-muted);
  font-size: 13px;
}

.link {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  justify-self: start;
  margin-block-start: var(--space-2);
  color: var(--color-primary);
}

.link:focus-visible {
  outline: 2px solid var(--color-focus);
  outline-offset: 2px;
}
